import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { apiUrl } from '../config/api';
import ClientLink from './ClientLink';

// The client a loan belongs to (full name and ID / passport number), for the
// header of a loan details panel. Staff read the client's profile; a client
// looking at their own loan reads theirs.
const LoanClientHeader = ({ loan }) => {
  const clientId = loan?.client_id ?? loan?.clientId ?? loan?.client?.id ?? null;
  const fromLoan = loan?.clientName || loan?.client_name
    || [loan?.first_name, loan?.middle_name, loan?.last_name].filter(Boolean).join(' ');
  const [client, setClient] = useState(fromLoan ? { name: fromLoan, idNo: loan?.id_passport_no || '' } : null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };
      let info = null;
      if (clientId) {
        try { info = (await axios.get(apiUrl(`/api/clients/${clientId}/profile`), { headers })).data?.personal_info; } catch {}
      }
      if (!info) {
        try { info = (await axios.get(apiUrl('/api/clients/my-profile'), { headers })).data?.personal_info; } catch {}
      }
      // A staff member without access to the profile must not see their own
      // details here: only use "my profile" when it is the loan's client.
      if (cancelled || !info || (clientId && info.id && Number(info.id) !== Number(clientId))) return;
      const name = [info.first_name, info.middle_name, info.last_name].filter(Boolean).join(' ') || info.full_name || fromLoan;
      setClient({ name, idNo: info.id_passport_no || '' });
    })();
    return () => { cancelled = true; };
  }, [clientId, fromLoan]);

  if (!client) return null;
  return (
    <div className="min-w-0 text-right">
      <div className="text-sm font-semibold text-gray-800 dark:text-slate-100 truncate">
        <ClientLink clientId={clientId} name={client.name} />
      </div>
      {client.idNo && (
        <div className="text-xs text-gray-500 dark:text-slate-400 truncate">ID / Passport No: {client.idNo}</div>
      )}
    </div>
  );
};

export default LoanClientHeader;
